export const parseTranslations = (translations) =>
  translations?.reduce(
    (prev, curr) => ({ ...prev, [curr.key]: curr.value }),
    {}
  );
